import * as React from 'react';
import { createContext, useContext, useState, type ReactNode } from 'react';

interface BlogStateContextType {
  selectedTag: string | null;
  setSelectedTag: (tag: string | null) => void;
  visibleCount: number;
  setVisibleCount: (count: number | ((prev: number) => number)) => void;
}

const BlogStateContext = createContext<BlogStateContextType | undefined>(undefined);

export const BlogStateProvider = ({ children }: { children: ReactNode }) => {
  const [selectedTag, setSelectedTag] = useState<string | null>(null);
  const [visibleCount, setVisibleCount] = useState(10); // POSTS_PER_PAGE 기본값

  return (
    <BlogStateContext.Provider value={{ selectedTag, setSelectedTag, visibleCount, setVisibleCount }}>
      {children}
    </BlogStateContext.Provider>
  );
};

export const useBlogState = () => {
  const context = useContext(BlogStateContext);
  if (context === undefined) {
    throw new Error('useBlogState must be used within a BlogStateProvider');
  }
  return context;
};
